import React from 'react';
import {
  MarketingImage,
  MarketingImageType,
} from 'components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from 'components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import { HomeSectionTitle } from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';

export function HomeGrow({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-grow.svg"
      textColumn={
        <>
          <HomeSectionTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'HomePage.HomeGrow.Title',
                '<strong>Advanced analytics and insights</strong> to help you understand and grow your audience.',
                'Anchor home page analytics features section title'
              ),
            }}
          />
          <MarketingBoldLink to="/features#analytics" onClick={onClickCTA}>
            {t(
              'HomePage.HomeGrow.AnalyticsFeaturesLinkText',
              'See all analytics features',
              'Anchor home page analytics features link text'
            )}
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <MarketingImage
          width={520}
          height={520}
          imagePath="home/analytics/analytics"
          imageType={MarketingImageType.PNG}
          alt={t(
            'HomePage.HomeGrow.AnalyticsImageAlt',
            'A picture of a person recording podcast on her laptop with headphones on',
            'Anchor home page analytics image screenreader information'
          )}
        />
      }
    />
  );
}
